import { Box, Grid, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import VideoStreamPlayer from 'components/Go2rtc/VideoStreamPlayer'
import RobotMissionMap from 'components/Robot/RobotMissionMap'
import RobotJoystick from 'components/RobotJoystick/RobotJoystick'
import useManualMode from 'hooks/useManualMode'
import useResize from 'hooks/useResize'
import useRobot from 'hooks/useRobot'
import { useUser } from 'hooks/user'
import { ReactComponent as DegreeSvg } from 'images/360Degree.svg'
import { ReactComponent as CameraSvg } from 'images/Camera.svg'
import { ReactComponent as IconCamSvg } from 'images/IconCam.svg'
import { ReactComponent as QuestionMarkIcon } from 'images/icons/faq.svg'
import { IoMdCloseCircleOutline } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { PATH } from 'utils/constants'

import ManualDataBlock from './ManualDataBlock'

import style from './ManualModePage.module.css'

const ManualModePage = () => {
  const navigate = useNavigate()
  const { data: robot } = useRobot()
  const { width } = useResize()
  const user = useUser()

  const handleBackClicked = () => {
    robot?.id && navigate(`${PATH.ROBOT_LIST}/${robot.id}`)
  }

  const {
    setLinearMotion,
    setAngularMotion,
    setSound,
    motionData,
    ping,
    webrtcUrl,
  } = useManualMode(robot?.serialNumber, user?.state.id)

  return (
    <div className={style.container}>
      <Grid className={style.manualMode} padding={2} container height="100%" width="100%">
        <Grid xs={12} md={7} item paddingY={2} height="100%" paddingRight={2}>
          <Box bgcolor="info.main" height="100%" borderRadius={4} overflow="auto">
            <Stack
              paddingLeft={2}
              paddingRight={2}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              height="5%"
            >
              <Box paddingTop={1}>
                <Typography variant="textDefault">Manual mode</Typography>
                <IconButton size="small" color="inherit" onClick={() => handleBackClicked()}>
                  <IoMdCloseCircleOutline />
                </IconButton>
              </Box>
              <Tooltip title="Справка по режиму Manual mode" placement="top">
                <IconButton size="small">
                  <QuestionMarkIcon />
                </IconButton>
              </Tooltip>
            </Stack>
            <Grid
              item
              paddingLeft={2}
              paddingRight={2}
              height="95%"
              display={'flex'}
              flexDirection="column"
              justifyContent="space-between"
            >
              <Grid
                item
                position="relative"
                display="flex"
                justifyContent="center"
                paddingTop={1}
                paddingBottom={2}
                maxHeight="70%"
                minHeight="60%"
              >
                <Box width="100%" height="100%">
                  <VideoStreamPlayer src={webrtcUrl} />
                </Box>
                <Stack spacing={{ xs: 0.5, lg: 2 }} sx={{ position: 'absolute', top: '5%', right: '3%' }}>
                  <Box className={style.buttonManual}>
                    <IconButton>
                      <CameraSvg />
                    </IconButton>
                  </Box>
                  <Box className={style.buttonManual}>
                    <IconButton>
                      <DegreeSvg />
                    </IconButton>
                  </Box>
                  <Box className={style.buttonManual}>
                    <IconButton>
                      <IconCamSvg />
                    </IconButton>
                  </Box>
                </Stack>
              </Grid>
              <Grid display="flex" alignItems="center" height="100%">
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  width="100%"
                  justifyContent="space-between"
                  paddingBottom={1}
                >
                  <Stack spacing={2}>
                    <Box height="100%">
                      <ManualDataBlock
                        header="Wheels turning angle, °"
                        value={
                          +(motionData.current_angular_speed ?? 0).toFixed(2) +
                          '/' +
                          (motionData.target_angular_speed ?? 0).toFixed(2)
                        }
                        tooltip=""
                      />
                    </Box>
                    <Box height="100%">
                      <ManualDataBlock
                        header="Speed, km/h"
                        value={
                          +(motionData.current_linear_speed ?? 0).toFixed(2) +
                          '/' +
                          (motionData.target_linear_speed ?? 0).toFixed(2)
                        }
                        tooltip=""
                        subtitle=""
                      />
                    </Box>
                  </Stack>
                  <Box margin="35px">
                    <RobotJoystick
                      baseColor="rgba(255, 255, 255, 0.8)"
                      onEngine={val => {
                        setLinearMotion(val)
                      }}
                      onRudder={val => {
                        setAngularMotion(val)
                      }}
                    />
                  </Box>
                  <Stack spacing={2}>
                    <Box height="100%">
                      <ManualDataBlock
                        header="Sound notification"
                        value={'-'}
                        tooltip=""
                        subtitle="Latency: 10.10.23 10:10 am"
                        showButtonIcon
                        onSignal={() => setSound('alert')}
                        offSignal={() => setSound('off')}
                      />
                    </Box>
                    <Box height="100%">
                      <ManualDataBlock header="Ping" value={ping} tooltip="" />
                    </Box>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        {width > 500 && (
          <Grid item xs={12} md={5} height="100%" paddingY={2}>
            <Box width="100%" height="100%" borderRadius={2} overflow="hidden">
              <RobotMissionMap />
            </Box>
          </Grid>
        )}
      </Grid>
    </div>
  )
}

export default ManualModePage
